import styled from '@emotion/styled'
import { ThemeFontSize } from '@open-tender/types'

const Body = styled.span<{ size?: ThemeFontSize }>`
  ${({ theme, size }) => `
    font-family: ${theme.fonts.body.family};
    font-weight: ${theme.fonts.body.weight};
    font-style: ${theme.fonts.body.fontStyle};
    letter-spacing: ${theme.fonts.body.letterSpacing};
    line-height: ${theme.fonts.body.lineHeight};
    text-transform: ${theme.fonts.body.textTransform};
    -webkit-font-smoothing: ${theme.fonts.body.fontSmoothing};
    color: ${theme.fonts.body.color};
    ${size ? `font-size: ${theme.fonts.sizes[size]};` : ''}
  `}
`

export default Body
